import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Modal from 'components/Modal/Modal';
import SvgIcon from 'components/SvgIcon/SvgIcon';

import verifiedBadge from '../../../Badges/Verified/verified.png';
import styles from '../Onboarding.module.scss';

const VERIFY_PATH = '/apply-for-verification';

const BENEFITS = [
  {
    title: 'A blue verified tick',
    text: 'on your profile, wherever clients see you.',
  },
  // {
  //   title: 'Priority placement',
  //   text: 'at the top of search results and featured pages.',
  // },
  {
    title: 'A trust signal',
    text: 'that sets you apart from unverified profiles.',
  },
];

const VerifiedInfoModal = ({ show, onClose }) => (
  <Modal
    show={show}
    onExit={onClose}
    closeButton
    animation="scale"
    modalStyle={{
      width: 'calc(100% - 40px)',
      maxWidth: 460,
      padding: '28px 28px 24px',
      borderRadius: 16,
      boxShadow: '0 16px 40px rgba(10, 26, 43, 0.18)',
    }}
  >
    <div className={styles.infoModal}>
      <div className={styles.infoModalHeader}>
        <img
          src={verifiedBadge}
          alt="Verified"
          className={styles.infoModalBadge}
        />
        <h3 className={styles.infoModalTitle}>What it means to be Verified</h3>
      </div>

      <p className={styles.infoModalIntro}>
        Verification tells clients you&rsquo;re a trusted expert on Twine.
      </p>

      <ul className={styles.infoModalList}>
        {BENEFITS.map((benefit) => (
          <li key={benefit.title} className={styles.infoModalListItem}>
            <SvgIcon
              icon="tick_circle"
              color="#0777da"
              size="18"
              className={styles.infoModalTick}
            />
            <span>
              <strong>{benefit.title}</strong> {benefit.text}
            </span>
          </li>
        ))}
      </ul>

      <div className={styles.infoModalDivider} />

      <p className={styles.infoModalHowToTitle}>How to apply</p>
      <p className={styles.infoModalHowTo}>
        Share your <strong>verified LinkedIn account</strong> and links to your{' '}
        <strong>portfolio, website, and social profiles</strong>. Our team
        reviews it and applies your badge once approved.
      </p>

      <div className={styles.infoModalActions}>
        <Link
          to={VERIFY_PATH}
          className={styles.verificationCta}
          onClick={onClose}
        >
          Apply for verification <span aria-hidden="true">&rarr;</span>
        </Link>
        <button
          type="button"
          className={styles.infoModalLater}
          onClick={onClose}
        >
          Maybe later
        </button>
      </div>
    </div>
  </Modal>
);

VerifiedInfoModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
};

export default VerifiedInfoModal;
